import loaderStyle from './Loader.module.scss';

const Loader = () => {
    return (
        <div className={loaderStyle.overlay} role='status' aria-live='polite'>
            <div className={loaderStyle.spinner} />
            <span className='srOnly'>Loading</span>
        </div>
    );
};

export default Loader;
